import React, {useEffect} from 'react';
import config from "../config";

const FacebookLoginButton = ({client, handleFacebookLogin}) => {
    useEffect(() => {
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: config.botPlatforms.messenger.appId,
                cookie: true,
                xfbml: false,
                version: 'v20.0',
            });
        };

        if (window.FB) {
            window.FB.init({
                appId: config.botPlatforms.messenger.appId,
                cookie: true,
                xfbml: false,
                version: 'v20.0',
            });
        }
    }, []);

    const handleLogin = () => {
        window.FB.login(
            (response) => {
                if (response.authResponse) {
                    const userAccessToken = response.authResponse.accessToken;
                    const tokenData = {userAccessToken: userAccessToken}
                    handleFacebookLogin(tokenData, client.id);
                }
            },
            {
                scope: 'public_profile,pages_show_list,pages_messaging,pages_read_engagement,pages_manage_metadata,instagram_basic,instagram_manage_messages',
            }
        );
    };


    return (
        <button
            onClick={handleLogin}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: '#1877F2',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                padding: '10px 20px',
                fontSize: 16,
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                transition: 'background-color 0.3s ease',
            }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#145dbf')}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#1877F2')}
            aria-label="Login with Facebook"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="white"
                width="20px"
                height="20px"
                style={{marginRight: 10}}
            >
                <path
                    d="M22.675 0h-21.35C.597 0 0 .592 0 1.324v21.352C0 23.406.597 24 1.325 24H12.82v-9.294H9.692v-3.622h3.127V8.413c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.464.099 2.796.143v3.24l-1.918.001c-1.504 0-1.795.716-1.795 1.764v2.314h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.324-.594 1.324-1.324V1.324C24 .592 23.405 0 22.675 0z"/>
            </svg>
            Login with Facebook
        </button>
    );
};

export default FacebookLoginButton;



// WEBPACK FOOTER //
// ./src/components-new/FacebookLoginButton.jsx